import array from '../array'
import enumerated, { KeysAndLabels } from '../enumerated'
import { ObjectType } from '../object'

export const select = (shape: ObjectType) =>
  array(
    enumerated(
      Object.keys(shape.shape).reduce((acc, key) => {
        acc[key] = shape.shape[key].currentMeta.label!
        return acc
      }, {} as KeysAndLabels<string>),
    ),
  ).isOptional()
